import { getVueContext } from 'src/common/context'
import { getCurrentInstance } from 'vue'

export function useHelpers(instance = getCurrentInstance()) {
  const vueInstance = instance?.appContext || getVueContext()
  return vueInstance ? vueInstance.config.globalProperties.$helpers : {}
}
